import React, { Component } from 'react';
import debounce from 'lodash/debounce';


export function detectTabFocus(){
  return (WrappedComponent) => {
    return class extends Component {

      TAB_FOCUS_CLASS_NAME = 'globalTabFocus'; // defined in src/index.scss as :global(.globalTabFocus)

      componentDidMount() {
        document.addEventListener('focusout', this.onDocumentFocusOut);
        document.addEventListener('keydown', this.onDocumentKeyDown);
      }

      componentWillUnmount(){
        document.removeEventListener('focusout', this.onDocumentFocusOut);
        document.removeEventListener('keydown', this.onDocumentKeyDown);
      }

      onDocumentFocusOut = (e) => {
        e.target.classList.remove(this.TAB_FOCUS_CLASS_NAME);
      };

      onDocumentKeyDown = (e) => {
        if (e.keyCode === 9) { // "Tab" key
          setTimeout(() => {
            document.activeElement.classList.add(this.TAB_FOCUS_CLASS_NAME);
          })
        }
      };

      render(){
        return (
          <WrappedComponent {...this.props} />
        );
      };
    };
  };
}


export function rerenderOnResize(){
  return (WrappedComponent) => {
    return class extends Component {

      componentDidMount() {
        window.addEventListener('resize', this.onWindowResize);
      }
      componentWillUnmount(){
        window.removeEventListener('resize', this.onWindowResize);
      }

      onWindowResize = debounce(() => {
        this.forceUpdate();
      }, 150);

      render(){
        return (
          <WrappedComponent {...this.props} />
        );
      };
    };
  };
}
